module.exports = __webpack_public_path__ + "img/videos.4ec07dca.png";